import { map, takeUntil } from 'rxjs/operators';
import { Component } from '@angular/core'
import { ActivatedRoute } from '@angular/router'

import { select, Store } from '@ngrx/store'
import { Observable } from 'rxjs'

import * as auth from '../../actions/account'
import * as fromAuth from '../../reducers'

import { ContainerBase } from '../../../core/base/container-base'

@Component({
  selector: 'app-activate-container',
  templateUrl: './template.html'
})
export class ActivateContainer extends ContainerBase {
  working$: Observable<boolean>
  success$: Observable<boolean>

  error$: Observable<any>

  constructor(
    private store: Store<fromAuth.AuthState>,
    private route: ActivatedRoute
  ) {
    super()

    route.params.pipe(takeUntil(this.destroyed$),
      map(params => new auth.Activate(params['token'])),)
      .subscribe(this.store)

    this.working$ = store.pipe(select(fromAuth.isWorking), takeUntil(this.destroyed$))
    this.success$ = store.pipe(select(fromAuth.isSuccessful), takeUntil(this.destroyed$))
    this.error$ = store.pipe(select(fromAuth.getActivateError), takeUntil(this.destroyed$))
  }
}
